export default "__VITE_PUBLIC_ASSET__792de928__"